// Messages for design-system/components/LocationCombobox (auto-merged by lib/i18n.ts).
export const en = {
  'location_combobox.no_match': 'No matching location.',
}

export const zhTW = {
  'location_combobox.no_match': '找不到符合的地點。',
}
